export const noOp = () => null;

export const scrollToTop = (top = 0) => {
  document.body.scrollTop = top;
  document.documentElement.scrollTop = top;
};

export const scrollToBottom = () => {
  window.scrollTo(0, window.innerHeight);
};

export const reloadPage = () => {
  window.location.reload();
};
